import { BreadcrumbProps } from 'packages/common-frontend/components/Breadcrumbs';
import { settingsPaths } from 'packages/sidebar/ui/sideBarUtils';

export const SettingsBreadcrumb: BreadcrumbProps = {
  label: 'Settings',
  path: settingsPaths.settings,
};

export const SettingsFacilitiesBreadcrumb: BreadcrumbProps = {
  label: 'Facilities',
  path: settingsPaths.facilities,
};
